const HTTP_STATUS_CODE = {
    OK: 200,
    CREATED: 201,
}

export { HTTP_STATUS_CODE }